module.exports = __webpack_public_path__ + "static/img/sjTwo.dff623b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjTwo.jpg
// module id = ZTfn
// module chunks = 1